import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AngularTokenService, ResetPasswordData } from '@raysuelzer/angular-token';

import { setPasswordResetMessage } from 'app/_state/auth/auth-actions';
import { AuthState } from 'app/_state/auth/auth-state';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {

  resetPasswordData: ResetPasswordData = {} as ResetPasswordData;
  errorMessages: Array<string>;

  constructor(
    private authService: AngularTokenService,
    private router: Router,
    private store: Store<AuthState>
  ) {
  }

  onSubmit() {
    this.errorMessages = [];

    this.authService
      .resetPassword(this.resetPasswordData)
      .subscribe((res) => {
        const message = res.success ? 'Password reset instructions sent' : res.errors.join(', ');
        this.store.dispatch(
          setPasswordResetMessage({message})
        );
        this.router.navigateByUrl(`/login`);
      }, res => {
        if (res.status.toString()[0] === '4') {
          this.errorMessages = res.error.errors;
        } else {
          console.error('Non 400 error:', res);
        }
      });
  }
}
